import { useEffect, useMemo } from "react";
import { useParams, useLocation } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import CampaignsDesktopList from "../../Campaigns/CampaignsDesktopList/campaignsDesktopList";

import { getCompletedCampaigns } from "../../../redux/state/campaignSlice";


const CompletedCampaigns = () => {
    const dispatch = useDispatch();
    const { pathname, search } = useLocation();
    const query = useMemo(() => new URLSearchParams(search), [search]);

    const { communityId } = useParams();
    const completedCampaigns = useSelector(state => state.campaign.completedCampaigns, shallowEqual);

    useEffect(() => {
        const page = parseInt(query.get('page') ?? 1);

        if (!communityId) return
        dispatch(getCompletedCampaigns({ communityId, page, pageSize: 9 }));

    }, [
        communityId,
        query,
        dispatch
    ])
    return <CampaignsDesktopList
        data={completedCampaigns}
        tableUrl={pathname}
        type="completed"
    />
}

export default CompletedCampaigns;